import styled from '@emotion/styled';
import { colors } from '@ui-components/neo.tax';
import { ReactComponent as CompanyIcon } from '@ui-components/neo.tax/dist/icons/company.svg';

export const StyledCompanyIcon = styled(CompanyIcon)({
  color: colors.blue[600],
  height: '1.5rem',
  width: '1.5rem',
});

export const FormStyled = styled.form({
  maxWidth: '660px',
});
